import { ZfIcon } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export const ErrorScreen: FunctionComponent = () => {
    const { t } = useTranslation();

    return (
        <div className="error-screen">
            <div className="error-screen__content">
                <div className="error-screen__details">
                    <div className="error-screen__details__title">
                        <ZfIcon className="error-screen__details__title__icon" name="info" />
                        <h3>{t('errorTitle')}</h3>
                    </div>
                    <span className="error-screen__details__sub-title">{t('somethingWentWrong')}</span>
                </div>
                <div className="error-screen__background-icon info" />
            </div>
        </div>
    );
};
